export const API_URL = "https://nuestrosautos.cca.org.ar/";
export const PREAPI_URL = "https://nuestrosautos.cca.org.ar/";
/**
 *
    export const API_URL = "https://na.loc/";
    export const PREAPI_URL = "https://na.loc/";

 */
